import { Component, ElementRef, HostListener, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy, OnChanges } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

import { MyErrorHandler } from '../../../../../tools/src/lib/errorhandler/errorhandler';
import { Grade, Year, Class, Subject } from '../../model/school.model';
import { I18nPluralPipe } from '@angular/common';

declare var jQuery;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-sch-assignteacher-form',
  templateUrl: './ctl.school.assignteacher.component.html',
  styleUrls: ['./ctl.school.assignteacher.component.css']
})


export class AssignTeacherToClassComponent implements OnInit, OnChanges {

  @Input() viewType: string;
  @Input() school_id: string;
  @Input() project_id: string;
  @Input() data;
  @Input() myForm: any;
  @Input() myGrade: any;
  @Input() myClass: any;
  @Input() mySubjectList = [];
  @Input() mySelectedSubjectsList = [];
  @Input() myTeachers = [];
  @Input() curAssignment;

  @Output() evRemoveSubject: EventEmitter<any> = new EventEmitter();
  @Output() evAddSubject: EventEmitter<any> = new EventEmitter();

  subjectList = [];
  selectedSubjectsList = [];
  mTeachers = [];
  mTeachers2 = [];

  subjectListId = [];
  loaded = false;

  curSubjectTeacher = [];

  curClass;
  teacherSelectConfig: any;
  
  textDir:any;

  
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    public translate: TranslateService,
    private route: ActivatedRoute) {
      
   this.textDir =  sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.translate.get('Select').subscribe((translated: string) => {
      this.teacherSelectConfig = {
        placeholder: translated,
        displayKey: 'name',
        search: false,
        height: '150px'
      };
    });
    if (this.mySubjectList) {
        this.subjectList = this.mySubjectList;
    }
    if (this.mySelectedSubjectsList) {
      this.selectedSubjectsList = this.mySelectedSubjectsList;
    }
    console.log("myGrade >>> "+this.myGrade)
  }

  ngAfterViewInit () {
    //
  }

  ngOnChanges() {
    //
    let it = 0;
    if (this.myForm.controls.subjectteacher.controls && this.mySubjectList){
      this.myForm.controls.subjectteacher.controls.forEach(element => {
        this.mySubjectList.forEach( item => {
          if (element.get('subject').value && item){
            if (element.get('subject').value._id === item._id){
              this.mTeachers[it] = [...this.myTeachers];
              this.mTeachers2[it] = [...this.myTeachers];
              let k = 0;
              this.mTeachers2[it].forEach(tchr => {
                if (tchr._id === element.get('teacher').value._id){
                  this.mTeachers2[it].splice(k, 1);
                }
                k++;
              });
            }
          }
        });
        it++;
      });
    }
  }

  removeSelectedFromSecondItem(itr,event){
    if (event.value){
      let indx = this.mTeachers2[itr].indexOf(event.value);
      if (indx !== '-1'){
        this.mTeachers2[itr].splice(indx,1);
        this.mTeachers2[itr] = [...this.mTeachers2[itr]];
      }
    }else{
      this.refreshSecondItem(itr);
    }
      
  }
  refreshSecondItem(itr){
    this.mTeachers[itr] = [...this.myTeachers];
    this.mTeachers2[itr] = [...this.myTeachers];
  }

  log(data){
    console.log('Kajal');
    console.log(data);
  }

  // ngDoCheck() {
  //   if (this.subjectList !== this.mySubjectList) {
  //       this.subjectList = this.mySubjectList;
  //       this.loaded = true;
  //   }
  //   if (this.selectedSubjectsList !== this.mySelectedSubjectsList) {
  //       this.selectedSubjectsList = this.mySelectedSubjectsList;
  //       this.loaded = true;
  //   }
  // }

  checkUncheckSubject(data) {
    console.log('changed ' + JSON.stringify(data));
  }

  removeSubject(value) {
    this.evRemoveSubject.emit(value);
  }

  onAddSubject(data) {
    this.evAddSubject.emit(data);
  }

  myListFormatter(item: any): string {
    console.log('data ' + JSON.stringify(item));
    if (item) {
      return `${item['name']}`;
    }
  }

  myValueFormatter(item: any): string {
    console.log('data ' + JSON.stringify(item));
    if (item) {
      return `${item['name']}`;
    }
  }

  updateCurClass(curclass) {
    jQuery('select').val('null');
    this.curClass = curclass;
    jQuery('#selectClass').val(curclass);
  }

  addToAssignmentList(cursubject, curteacher) {
    if(this.viewType!=='edit')
       this.curClass = this.myClass._id;
    //console.log('cur class ' + this.curClass || this.myGrade.classes[0]._id);
   // console.log('cur class ' + this.curClass._id);
    //console.log('cur subject ' + cursubject.name);
    //console.log('cur teacher ' + curteacher);
    // check if mapping exists
    //console.log('before assignment == ' + JSON.stringify(this.curAssignment));

    if (Array.isArray(this.curAssignment)) {
      let cflag = 0;
      let i = 0;
      this.curAssignment.forEach( e => {
        if (e.class_id === this.curClass) {
          let subjectteacher = [];
          subjectteacher = e.subjectteacher.slice();
          let sflag = 0;
          let j = 0;
          subjectteacher.forEach( f => {
            if (f.subject_id === cursubject._id) {
              subjectteacher[j].subject_id = cursubject._id;
              subjectteacher[j].teacher_id = curteacher;
              // subjectteacher[j].teacher_two_id = subjectteacher[j].teacher_two_id || subjectteacher[j].secondteacher._id || null;
              if (subjectteacher[j].teacher_two_id) {
                subjectteacher[j].teacher_two_id = subjectteacher[j].teacher_two_id;
              } else if (subjectteacher[j].secondteacher._id) {
                subjectteacher[j].teacher_two_id = subjectteacher[j].secondteacher._id;
              } else {
                if (subjectteacher[j].teacher_two_id) {
                  delete subjectteacher[j].teacher_two_id;
                }
              }
              sflag = 1;
            }
            j++;
          });
          if (sflag === 0) {
            subjectteacher[j] = {};
            subjectteacher[j].subject_id = cursubject._id;
            subjectteacher[j].teacher_id = curteacher;
          }
          this.curAssignment[i].class_id = this.curClass;
          this.curAssignment[i].subjectteacher = subjectteacher.slice();
          cflag = 1;
        }
        i++;
      });

      if (cflag === 0) {
        // this.curAssignment = [];
        this.curAssignment.push({'class_id': this.curClass, 'subjectteacher': [{'subject_id': cursubject._id, 'teacher_id': curteacher}]});
      }
    } else  {
      let subjectteacher = [];
      if (this.curAssignment && this.curAssignment.subjectteacher) {
        subjectteacher = this.curAssignment.subjectteacher.slice();
      }
      let sflag = 0;
      let j = 0;
      subjectteacher.forEach( f => {
        if (f.subject_id === cursubject._id) {
          subjectteacher[j].subject_id = cursubject._id;
          subjectteacher[j].teacher_id = curteacher;
          // subjectteacher[j].teacher_two_id = subjectteacher[j].teacher_two_id || subjectteacher[j].secondteacher._id || null;
          if (subjectteacher[j].teacher_two_id) {
            subjectteacher[j].teacher_two_id = subjectteacher[j].teacher_two_id;
          } else if (subjectteacher[j].secondteacher._id) {
            subjectteacher[j].teacher_two_id = subjectteacher[j].secondteacher._id;
          } else {
            if (subjectteacher[j].teacher_two_id) {
              delete subjectteacher[j].teacher_two_id;
            }
          }
          sflag = 1;
        }
        j++;
      });
      if (sflag === 0) {
        subjectteacher[0] = {};
        subjectteacher[0].subject_id = cursubject._id;
        subjectteacher[0].teacher_id = curteacher;
      }
      this.curAssignment.subjectteacher = subjectteacher.slice();
    }
    //console.log('after assignment == ' + JSON.stringify(this.curAssignment));
  }
/*
  updateAssignmentListTwo(cursubject, curteacher) {
    console.log('cur class ' + this.curClass || this.myGrade.classes[0]._id);
    console.log('cur subject ' + cursubject.name);
    console.log('cur teacher ' + curteacher);
    // check if mapping exists
    console.log('before assignment == ' + JSON.stringify(this.curAssignment));

    if (Array.isArray(this.curAssignment)) {
      let cflag = 0;
      let i = 0;
      this.curAssignment.forEach( e => {
        if (e.class_id === this.curClass) {
          let subjectteacher = [];
          subjectteacher = e.subjectteacher.slice();
          let sflag = 0;
          let j = 0;
          subjectteacher.forEach( f => {
            if (f.subject_id === cursubject._id) {
              subjectteacher[j].subject_id = cursubject._id;
              subjectteacher[j].teacher_id = subjectteacher[j].teacher_id || subjectteacher[j].firstteacher._id || null;
              subjectteacher[j].teacher_two_id = curteacher;
              sflag = 1;
            }
            j++;
          });
          if (sflag === 0) {
            subjectteacher[j] = {};
            subjectteacher[j].subject_id = cursubject._id;
            subjectteacher[j].teacher_two_id = curteacher;
          }
          this.curAssignment[i].class_id = this.curClass;
          this.curAssignment[i].subjectteacher = subjectteacher.slice();
          cflag = 1;
        }
        i++;
      });

      if (cflag === 0) {
        // this.curAssignment = [];
        this.curAssignment.push({'class_id': this.curClass, 'subjectteacher': [{'subject_id': cursubject._id, 'teacher_two_id': curteacher}]});
      }
    } else  {
      let subjectteacher = [];
      if (this.curAssignment.subjectteacher) {
        subjectteacher = this.curAssignment.subjectteacher.slice();
      }
      let sflag = 0;
      let j = 0;
      subjectteacher.forEach( f => {
        if (f.subject_id === cursubject._id) {
          subjectteacher[j].subject_id = cursubject._id;
          subjectteacher[j].teacher_id = subjectteacher[j].teacher_id || subjectteacher[j].firstteacher._id || null;
          subjectteacher[j].teacher_two_id = curteacher;
          sflag = 1;
        }
        j++;
      });
      if (sflag === 0) {
        subjectteacher[0] = {};
        subjectteacher[0].subject_id = cursubject._id;
        subjectteacher[0].teacher_two_id = curteacher;
      }
      this.curAssignment.subjectteacher = subjectteacher.slice();
    }

    console.log('after assignment == ' + JSON.stringify(this.curAssignment));
  }

  */

  updateAssignmentList(cursubject, curteacher) {
    console.log('cur class ' + this.curClass || this.myGrade.classes[0]._id);
    console.log('cur subject ' + cursubject.name);
    console.log('cur teacher ' + curteacher);

    let curSubjectTeacher = this.populateSubjectTeacher(this.data.subjectteacher, this.myForm.get('subjectteacher').value);
    let sflag = 0;
    let j = 0;
    curSubjectTeacher.forEach( f => {
      if (f.subject_id === cursubject._id) {
        curSubjectTeacher[j].subject_id = cursubject._id;
        curSubjectTeacher[j].teacher_id = curteacher;
        sflag = 1;
      }
      j++;
    });
    if (sflag === 0) {
      curSubjectTeacher[0] = {};
      curSubjectTeacher[0].subject_id = cursubject._id;
      curSubjectTeacher[0].teacher_id = curteacher;
    }
    this.myForm.get('subjectteacher').patchValue(curSubjectTeacher);
    console.log('after assignment == ' + JSON.stringify(curSubjectTeacher));
  }

  updateAssignmentListTwo(cursubject, curteacher) {
    console.log('cur class ' + this.curClass || this.myGrade.classes[0]._id);
    console.log('cur subject ' + cursubject.name);
    console.log('cur teacher ' + curteacher);

    let curSubjectTeacher = this.populateSubjectTeacher(this.data.subjectteacher, this.myForm.get('subjectteacher').value);
    let sflag = 0;
    let j = 0;
    curSubjectTeacher.forEach( f => {
      if (f.subject_id === cursubject._id) {
        curSubjectTeacher[j].subject_id = cursubject._id;
        curSubjectTeacher[j].teacher_two_id = curteacher;
        sflag = 1;
      }
      j++;
    });
    if (sflag === 0) {
      curSubjectTeacher[0] = {};
      curSubjectTeacher[0].subject_id = cursubject._id;
      curSubjectTeacher[0].teacher_two_id = curteacher;
    }
    this.myForm.get('subjectteacher').patchValue(curSubjectTeacher);
    console.log('after assignment == ' + JSON.stringify(curSubjectTeacher));
  }

  populateSubjectTeacher(subteach, subteachform) {
    let result: any[] = [];
    if (!subteach || !Array.isArray(subteach)) {
      return result;
    }

    if (subteachform && subteachform.length) {
      let i = 0;
      let j = 0;
      subteachform.forEach(e => {
        let s_id = null;
        let t_id = null;
        let t_2_id = null;
        if (e.subject_id) {
          s_id = e.subject_id;
        }
        if (e.teacher_id) {
          t_id = e.teacher_id;
        }
        if (e.teacher_two_id) {
          t_2_id = e.teacher_two_id;
        }

        result.push({
          'subject_id': s_id,
          'teacher_id': t_id,
          'teacher_two_id': t_2_id
        });
      });
    } else {
      if (subteach && subteach.length) {
        let s_id = null;
        let t_id = null;
        let t_2_id = null;
        subteach.forEach(f => {
          if (f.subject && f.subject._id) {
            s_id = f.subject._id;
          }
          if (f.firstteacher && f.firstteacher._id) {
            t_id = f.firstteacher._id;
          }
          if (f.secondteacher && f.secondteacher._id) {
            t_2_id = f.secondteacher._id;
          }

          result.push({
            'subject_id': s_id,
            'teacher_id': t_id,
            'teacher_two_id': t_2_id
          });
        });
      }
    }
    return result;
  }

  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG');
  }

}
